
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class ContractBaseService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    getAllByCustomer(customerId: number) {
        return this.http.get('api/ContractBase/GetAllByCustomer/' + customerId, this.getAuthHeader(true));
    }

    getContractBaseFromCustomerId(customerId: number) {
        return this.http.get('api/ContractBase/GetAllContractBaseWithEANCodeAddress/' + customerId, this.getAuthHeader(true));
    }

    getCount() {
        return this.http.get('api/ContractBase/GetCount', this.getAuthHeader(true));
    }

    exportExcel(ids: string) {
        return this.http.get(`/api/ContractBase/ExportExcel/${ids}`, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        const options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/contract-base.service.ts